export const trendFactors = [
  { id: "power", name: "Power Squeeze" },
  { id: "surfing", name: "Surfing Trend" },
] as const;

export type TrendFactor = (typeof trendFactors)[number]["id"];
